module.exports = __webpack_public_path__ + "static/img/10.64f6701.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/zh/10.png
// module id = QqAR
// module chunks = 0